import * as Immutable from 'immutable';
import { Price } from '../../UIData/_stores/UIDataStore';
import { IPaginationStore, PaginationItem } from './PaginationStore';
import UserCartStore from './UserCartStore';

export interface IUserOrderListStore extends IPaginationStore {
	items: Immutable.OrderedMap<string, UserCartStore>,
}

const defaultUserOrderListStore = Immutable.Record<IPaginationStore>({
	items: Immutable.OrderedMap<string, UserCartStore>(),
	total: 0,
	valid: false,
	loading: false,
});

export default class UserOrderListStore extends defaultUserOrderListStore implements IUserOrderListStore {}